export default __webpack_public_path__ + "static/f1-a17798822ee67a35cf3aa71968e62973.jpg";